import { OxCheckbox, TOxCheckboxProps } from '../OxCheckbox';

import React from 'react';

export const OxRadio = (props: SCProps<'input', TOxCheckboxProps>): JSX.Element => {
    return <OxCheckbox {...props} type="radio" />;
};
